import React, { useState, useEffect } from 'react';
import { Table, Space, Button, Card, Layout, Menu, Form, Input, Select, Switch } from 'antd';
import {Await, Link, useLocation, useNavigate} from 'react-router-dom';
import axios from 'axios'; // Import axios library

import Sidebar from '../../Side_Bar/Admin_Side_Bar';
const { Option } = Select;

const View_Customer_Viewer = () => {
  const [userData, setUsersData] = useState([]);
  const [customerData, setCustomerData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();

  const mainUrl                       = "https://chatbot-summary-deployment-dot-fartech-yvqj.et.r.appspot.com/";
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${mainUrl}/getAllTable?tableName=User`);
        // const response2 = await fetch(`${mainUrl}/getAllTable?tableName=User`);

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        let customer_data = await response.json();

        customer_data = customer_data.filter(user => user.user_type === 'Viewer');

        // Adding 'index' property to each object in the array
        const dataWithIndex = customer_data.map((item, index) => ({
          ...item,
          index: index + 1, // Assuming you want to start the index from 1
        }));

        setCustomerData(dataWithIndex);
        setIsLoading(false);

      } catch (error) {
        console.error('Error fetching table data:', error);
        throw error;
      }
    };

    fetchData();

  }, [])

  const [editRow, setEditRow] = useState(null);
  const [form] = Form.useForm();

  // Columns for the table
  const columns = [
        {
          title: 'NO.',
          dataIndex: 'index',
          key: 'index',
          render: (text, record) => {
            if (editRow === record.index) {
              return (
                <Form.Item
                  name = "customer_id"
                  initialValue={text}
                >
                  <Input disabled/>
                </Form.Item>
              );
            }
            return text;
          },
      },
      {
          title: 'USERNAME',
          dataIndex: 'username',
          key: 'username',
          render: (text, record) => {
            if (editRow === record.index) {
              return (
                <Form.Item
                  name = "username"
                  initialValue={text}
                >
                  <Input disabled/>
                </Form.Item>
              );
            }
            return text;
          },
      },
      {
        title: 'USER STATUS',
        dataIndex: 'is_active',
        key: 'is_active',
        render: (text, record) => {
          return (
            <Form.Item 
            name={`is_active_${record.index}`} 
            valuePropName="checked"
            initialValue={(text === 1)? true:false}
            >
              <Switch 
              onChange={() => handleSwitchChange(record)} 
              />
            </Form.Item>
          );
        },
      },
  ];

  const handleSwitchChange = (record) => {
    const isEnabled = form.getFieldValue(`is_active_${record.index}`);

    const updatedData = {
      username: record.username,
      is_active: isEnabled
    };

    try{
      axios.put(mainUrl + `/updateUserStatus`, updatedData)
      .then(response => {
        console.log('Updated Company Cost:', response.data);
      })
      .catch(error => {
        console.error('Error updating company cost:', error.response ? error.response.data : error.message);
      });

    } catch (error) {
      console.error('Error updating customer:', error);
    } 

  };

  const onFinish = async(values) =>{
    const updatedDataSource = [...customerData];
    updatedDataSource.splice(editRow-1, 1, { ...values, index: editRow });
    setCustomerData(updatedDataSource);
    setEditRow(null);
    
    const updateUser = {
      username: form.getFieldValue('username'),
      is_active: form.getFieldValue('is_active') == "true"? true: false
    };

    try{

      // Make the second PUT request and wait for it to complete
      const userResult = await updateUserStatus(updateUser);

    }catch (e){
      console.log("Error: ", e)
    }
  }

  const updateUserStatus = async (user) => {
    try {
      const userResponse = await axios.put(`${mainUrl}/updateUserStatus`, user);
      console.log('Updated User Status:', userResponse.data);
      return userResponse.data; // You can return data or any other information if needed
    } catch (error) {
      console.error('Error updating user status:', error.response ? error.response.data : error.message);
      throw error; // Re-throw the error to propagate it to the calling function
    }
  };

  const onAddCustomerClick = () => {
    navigate('/add_viewer');
  }

  if (isLoading) {
    return <p>Loading...</p>;
  }

  return (
    <Layout style={{ minHeight: '98vh' }}>
       <Sidebar location={location} />
        <Layout style={{ background: 'white'}}>
          <div style={{ maxWidth: '100%', margin: '30px', textAlign: 'center', fontFamily: 'Helvetica, Arial, sans-serif' }}>
          <Card 
              title={<span style={{ fontSize: '20px', fontWeight: 'bold' }}>COMPANY VIEWER INFORMATION</span>} 
              style={{ maxWidth: '100%', maxHeight: "100%" }}
          >
            <div 
              style={{ 
                display: 'flex', 
                justifyContent: 'flex-end', 
                alignItems: 'center',
                marginBottom: "1%"}}>
                  <Button
                    style={{ 
                      height: "50px", 
                      background: "#00308F",
                      color: "white" }}
                      onClick={()=>{onAddCustomerClick()}}
                    >
                    + Add Viewer
                  </Button>
            </div>
              <div style={{ overflowX: 'auto' }}>
                <Form form = {form} onFinish={onFinish}>
                  <Table 
                  dataSource={customerData} 
                  columns={columns}
                  scroll={{ x: 100, y: 1500 }}
                  />
                </Form>
              </div>
            </Card>
          </div>
        </Layout>
      </Layout>
  );
};

export default View_Customer_Viewer;